<div class="container-fluid admin-form-page">
  <div class="row section1 align-items-center">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Create new user</h5>
        <p class="home-subtitle">Fill all the below fields (Fields with * are mandatory)</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5 ">
      <div class="dashboard-btn dashboard-manage admin-page-actions mr-3">
        <div> <a routerLink="/users"><button type="button" class="btn btn-primary btn-dashboard">Back</button></a></div>
        <div>
        </div>
      </div>
    </div>
  </div>
  <div class="section1">
    <div class="applicants-details details1 admin-form-card">
      <form class="admin-form" (ngSubmit)="createProfile()" ngNativeValidate>
        <div class="row align-items-center">
          <div class="col-auto ">
            <div class="user-form">
              <div class="form-group d-flex flex-column">
                <label>Profile Picture*</label>
                @if (payload.profile) {
                  <img class="position-relative rounded-circle" style="object-fit: cover" width="100" height="100"
                    src="{{payload.profile}}" alt="">
                }
                @if (!payload.profile) {
                  <img class="position-relative rounded-circle" style="object-fit: cover" width="100"
                    height="100"
                    src="assets/images/placeholder.png" alt="">
                  }
                  @if (!payload.profile && !uploading) {
                    <i (click)="handleClickUpload()"
                    class="las font-size-16 la-plus-circle img-icon"></i>
                  }
                  @if (payload.profile && !uploading) {
                    <i (click)="handleClickUpload()"
                    class="las font-size-16 la-pencil-alt img-icon"></i>
                  }
                  @if (uploading) {
                    <div class="img-icon-loader">
                      <img src="assets/images/loading.gif" width="40" alt="">
                    </div>
                  }
                </div>
                <input id="dp" name="file-upload-field" type="file"
                  accept=".png, .jpg, .jpeg, .webp"
                  class="form-control d-none"
                  (change)="uploadImage($event)" required>
              </div>
            </div>
            <div class="col-4 ">
              <div class="user-form">
                <div class="form-group">
                  <label for="first-name">First Name*</label>
                  <input type="text" class="form-control" id="first-name" name="first-name"
                    [(ngModel)]="payload.firstName"
                    placeholder="Enter First Name" required autocomplete="off">
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="user-form">
                <div class="form-group">
                  <label for="last-name">Last Name*</label>
                  <input type="text" class="form-control" id="last-name" name="last-name" [(ngModel)]="payload.lastName"
                    placeholder="Enter Last Name" required autocomplete="off">
                </div>
              </div>
            </div>
            <div class="col ">
              <div class="user-form textarea">
                <div class="form-group">
                  <label for="userType">User Type*</label>
                  <select class="form-control" [(ngModel)]="payload.type" name="userType" id="userType" required>
                    <option value="Bhakt">Bhakt</option>
                    <option value="Vishwaguru">Vishwaguru</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-4 ">
              <div class="user-form">
                <div class="form-group">
                  <label for="email">Email (Email or Twitter required)</label>
                  <input type="email" class="form-control" name="email" [(ngModel)]="payload.email" id="email"
                    placeholder="Enter Email" [required]="!payload.twitterHandle.trim()">
                </div>
              </div>
            </div>
            <div class="col-4 ">
              <div class="user-form">
                <div class="form-group">
                  <label for="contact">Contact Number</label>
                  <input type="tel" class="form-control" name="phone" id="contact" [(ngModel)]="payload.phone"
                    maxlength="10" placeholder="Enter Contact No."
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')">
                  </div>
                </div>
              </div>
              <div class="col-4 ">
                <div class="user-form">
                  <div class="form-group">
                    <label for="password">Password*</label>
                    <input type="password" class="form-control" name="password" id="password" autocomplete="new-password"
                      [(ngModel)]="payload.password" placeholder="Enter your Password" required>
                  </div>
                </div>
              </div>
              <div class="col-7 ">
                <div class="user-form textarea">
                  <div class="form-group">
                    <label for="bio">Bio</label>
                    <textarea class="form-control" [(ngModel)]="payload.bio" name="bio" placeholder="Enter your bio"
                    id="bio"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="user-form">
                  <div class="form-group">
                    <label for="twitter-user-name">Twitter user name (Email or Twitter required)</label>
                    <input type="text" class="form-control" id="twitter-user-name" name="twitterHandle" [(ngModel)]="payload.twitterHandle"
                      placeholder="Enter twitter user name" autocomplete="off" [required]="!payload.email.trim()">
                  </div>
                </div>
              </div>
              <div class="col ">
                <div class="user-form textarea">
                  <div class="form-group">
                    <label for="userType">Super user</label>
                    <select class="form-control" [(ngModel)]="payload.canManageUnclaimedUserActivity" name="superUser" id="superUser">
                      <option [value]=true>Yes</option>
                      <option [value]=false>No</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-end mt-3 mr-1">
              <button class="btn btn-primary btn-dashboard" >Save user details</button>
            </div>

          </form>
        </div>
      </div>
    </div>
